import { useEffect, useState } from 'react';
import { getUrbanZoning } from '../../services/urbanZoningService';

/**
 * Carga la zonificación normativa de un lote vía GET /geturbanzoning.
 * Preferir un único hook por pantalla para evitar fetches duplicados.
 */
export function useUrbanZoning({ zoningPerfil, blocked = false }) {
  const [status, setStatus] = useState('idle');
  const [zoningData, setZoningData] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const perfil = String(zoningPerfil || '').trim();
  const hasPerfil = perfil.length > 0;

  useEffect(() => {
    if (blocked) {
      setStatus('blocked');
      setZoningData(null);
      setErrorMessage('');
      return undefined;
    }

    if (!hasPerfil) {
      setStatus('unavailable');
      setZoningData(null);
      setErrorMessage('');
      return undefined;
    }

    let cancelled = false;
    setStatus('loading');
    setZoningData(null);
    setErrorMessage('');

    const load = async () => {
      try {
        const result = await getUrbanZoning(perfil);
        if (cancelled) return;

        if (result.ok && result.data) {
          setZoningData(result.data);
          setStatus('ready');
          return;
        }

        setZoningData(null);
        setStatus('error');
        setErrorMessage(
          result.status === 404
            ? 'No encontramos normas urbanísticas para este perfil.'
            : (result.message || 'No pudimos cargar la información de zonificación urbana.'),
        );
      } catch {
        if (cancelled) return;
        setZoningData(null);
        setStatus('error');
        setErrorMessage('No pudimos cargar la información de zonificación urbana.');
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [blocked, hasPerfil, perfil]);

  return {
    status,
    zoningData,
    errorMessage,
    hasPerfil,
    perfil,
  };
}
